import { axiosClient } from "@/api/axios";

export function getSemesters() {
  return axiosClient.get(`semesters`);
}

export function getAcademyYears() {
  return axiosClient.get(`semesters/academy-years`);
}
